export const allEstates = [
  {
    estate: "public",
    name: "Public Estate",
    description: "Home to the public Reedharvesters, Stockbreeders, public hunters, and the Conservationists, the public estate is the common grounds of the land, available for use to the public.  It occupies the right side of the map, and has many different interest groups vying for its use. Negotiation is essential for success.",
    color: "#d9d9d9",
  },
  {
    estate: "private",
    name: "Private Estate",
    description: "Home to the Private Hunters and Public reed harvesters, the private estate has a lesser diversity in interests, but a greater intensity of resource exploitation. Despite this, wild life is somewhat more common due to the secluded nature of the place. Correct distribution of resources and responsible resource extraction is essential for success.",
    color: "#bdbfc5",
  },
];


const globalActions = [
  "clearing",
  "embank",
  "disembank",
]

export function getRoleConstants(role:string, estate:string){
  for(let r of allRoles){
    if(r.role === role && r.estate === estate){
      return r;
    }
  }
}


export const allRoles = [
  {
    role: "Reed Harvester",
    estate: "public",
    description: "Harvests reeds in winter, which are harvestable in shallow water or higher. Tries to maximize and conserve the reedlands for sustainable harvesting. Dry spring conditions increase harvesting profits. Try to harvest at least 14 cells a year!",
    color: "#d1a144",
    actions: [
      ...globalActions,
      'cut',
    ],
    staticCosts:[
      [6000, "Harvesting Machine Cost"],
      [16000, "Machine Operator Salary"]
    ],
    initialMoney: 5000,
    initialSubsidies:0,
  },
  {
    role: "Reed Harvester",
    estate: "private",
    description: "Harvests reeds in winter, which are harvestable in shallow water or higher. Tries to maximize and conserve the reedlands for sustainable harvesting. Dry spring conditions increase harvesting profits. Try to harvest at least 14 cells a year!",
    color: "#d0a13b",
    actions: [
      ...globalActions,
      'cut',
    ],
    staticCosts:[
      [6000, "Harvesting Machine Cost"],
      [16000, "Machine Operator Salary"]
    ],
    initialMoney: 5000,
    initialSubsidies:0,
  },
  {
    role: "Stockbreeder",
    estate: "public",
    description: "Try to grow your herd of cattle and maximize your grazing space. Shallow water or higher needed to graze, and fodder is expensive! Try to grow your cattle, and help other players with your wealth.",
    color: "#4dc5c5",
    actions: [
      ...globalActions,
      'grazing',
    ],
    staticCosts:[
      [4000, "Farm upkeep costs"],
      [15000, "Farm laborer salaries"]
    ],
    initialMoney: 5000,
    initialSubsidies:0,
    initialHerdSize: 50,
    animalValue: 600, // cost to buy / sell an animal
    animalProductivity: 400, // how much value an animal produces each year. Idk maybe they shed steaks or something lol.
    feedCost:10, // feed cost per animal 
  },
  {
    role: "Conservationist",
    estate: "public",
    description: "Protect the bird inhabitants of the reedland. Roleplay as a conservationist, and convince other players to pursue policies that protect Ducks, Bitterns, and Herons. Create nature reserves and negotiate their protections.",
    color: "#d472e1",
    actions: [
      ...globalActions,
      'create-nature-reserve',
    ],
    staticCosts:[
      [500, "Scientific Monitoring Costs"]
    ],
    initialMoney: 5000,
    initialSubsidies:500, // just enough to cover costs. if they do well they can slowly gain money to do.... something with.
  },
  {
    role: "Hunter",
    estate: "public",
    description: "Hunt on foot or by boat during the winter. Ducks prefer high water levels and open tracks of land. You will get a subsidy from the government for hunting ducks. Try to maximize the size of duck habitats.",
    color: "#d37870",
    actions: [
      ...globalActions,
      'public-hunt',
    ],
    staticCosts:[],
    // no static costs. super chill role IMO
    initialMoney: 1000,
    initialSubsidies:0,
  },
  {
    role: "Hunter",
    estate: "private",
    description: "Hunt on foot or by boat during the winter. Ducks prefer high water levels and open tracks of land. Each duck you tag will give you cash, which you can use to set up embankments to increase the size of duck habitats.",
    color: "#d0654e",
    actions: [
      ...globalActions,
      'private-hunt',
    ],
    staticCosts:[
      [1000, "Hunting lodge upkeep cost"],
      [1500, "Hunting lodge guard salary"]
    ],
    valuePerDuck:24, // derived via algebra from the original insane equation with 120 ducks as the break even point
    initialMoney: 1000,
    initialSubsidies:0,
  },
]
interface Action {
  label : string;
  description: string;
  kind: "mapAction" | "muAction" | "otherAction" | "faunaAction";
  icon?:string;
  simType?: string | number;
}
export const actions: Record<string, Action> = {
  "clearing": {
    label: "clear",
    description: "Clear Land MU",
    kind: "mapAction",
    icon: "/ActionIcons/clearing.png",
    simType: 2,
  },
  "embank": {
    label: "Dike",
    description: "Embank",
    kind: "muAction",
    // icon: "/common/icons/embank.png",
    simType: "EMBANK",
  },
  "disembank": {
    label: "Clear Dike",
    description: "description",
    kind: "muAction",
    // icon: "/common/icons/disembank.png",
    simType: "DISEMBANK",
  },
  "cut": {
    label: "cut",
    description: "description",
    kind: "mapAction",
    icon: "/ActionIcons/cut.png",
    simType: 3,
  },
  "buy-cow": {
    label: "buy cow",
    description: "description",
    kind: "otherAction",
  },
  "sell-cow": {
    label: "sell cow",
    description: "description",
    kind: "otherAction",
  },
  "grazing": {
    label: "graze",
    description: "description",
    kind: "mapAction",
    icon: "/ActionIcons/grazing.png",
    simType: 1,
  },
  "create-nature-reserve": {
    label: "create nature reserve",
    description: "description",
    kind: "muAction",
    // icon: "/common/icons/create-nature-reserve.png",
    simType: "NATURE_RESERVE",
  },
  "private-hunt": {
    label: "hunt",
    description: "description",
    kind: "faunaAction",
    icon: "/ActionIcons/hunt.png",
  },
  "public-hunt": {
    label: "hunt",
    description: "description",
    kind: "faunaAction",
    icon: "/ActionIcons/hunt.png",
  },
}

export const managementUnits = Array.from({length: 20}, (_, i) => ({
  label: `Unit ${i + 1}`,
  color: `hsl(${i * 18}, ${(i % 2 === 0) ? 100 : 60}%, ${(i % 3 === 0) ? 50 : 40}%)`,
  // this alternates the colors of the management units. It increases the hue and alternates between two saturation and lightness values to make it more distinct.
}));

export function numToLandType (i : number) {
  const aba = [
    {
      name: "open water",
      color: "#55a2e4",
    },
    {
      name: "culture",
      color: "#D2B48C",
    },
    {
      name: "meadow",
      color: "#b0ce60",
    },
    {
      name: "meadow shrubs",
      color: "#f2d08d",
    },
    {
      name: "meadow reed",
      color: "#BDB76B",
    },
    {
      name: "reedbed",
      color: "#e79f3b",
    },
    {
      name: "reed shrubs",
      color: "#556B2F",
    },
    {
      name: "reed water",
      color: "#aad8ce",
    },
    {
      name: "forest",
      color: "#5e9432",
    },
  ]
  return aba[i]
}

export const landTypes = {
  "OPEN_WATER": {
    name: "open water",
    color: "#55a2e4",
  },
  "REED_WATER": {
    name: "reed water",
    color: "#aad8ce",
  },
  "REEDBED": {
    name: "reedbed",
    color: "#e79f3b",
  },
  "MEADOW_SHRUBS": {
    name: "meadow shrubs",
    color: "#f2d08d",
  },
  "MEADOW_REED": {
    name: "meadow reed",
    color: "#BDB76B",
  },
  "MEADOW": {
    name: "meadow",
    color: "#b0ce60",
  },
  "REED_SHRUBS": {
    name: "reed shrubs",
    color: "#556B2F",
  },
  "FOREST": {
    name: "forest",
    color: "#5e9432",
  },
  "CULTURE": {
    name: "culture",
    color: "#D2B48C",
  },
}

export const birdTypeStuff = {
  "DUCK": {
    icon: "/ActionIcons/duck.png",
    label: "duck",
  },
  "BOOMING_BITTERN":{
    icon: "/ActionIcons/bittern.png",
    label: "booming bittern",
  },
  "PURPLE_HERON_COLONY":{
    icon: "/ActionIcons/purple-heron.png",
    label: "purple heron colony",
  }
}
